import { UserDataModel } from '@modules/auth';

export enum RoleName {
  BASIC = 'Basic',
  MODERATOR = 'Moderator',
  ADMIN = 'Admin',
  SUPER_ADMIN = 'SuperAdmin',
}

export const isUserBasic = (user: UserDataModel): boolean => {
  return user.roles.length === 1 || user.roles.includes(RoleName.BASIC);
};

export const isUserNotBasic = (user: UserDataModel): boolean => {
  return [RoleName.MODERATOR, RoleName.ADMIN, RoleName.SUPER_ADMIN].some(role => user.roles.includes(role));
};

export const isUserModerator = (user: UserDataModel): boolean => {
  return [RoleName.MODERATOR].some(role => user.roles.includes(role));
};

export const isUserAdmin = (user: UserDataModel): boolean => {
  return [RoleName.ADMIN, RoleName.SUPER_ADMIN].some(role => user.roles.includes(role));
};

export const isUserSuperAdmin = (user: UserDataModel): boolean => {
  return [RoleName.SUPER_ADMIN].some(role => user.roles.includes(role));
};
